import { createTheme } from '@mui/material/styles';
import { Colors } from '../Colors';
import { palette } from '../Palette';
import { Shadows } from '../Shadows';
import { createBranchTypography } from '../Typography';
import { Components } from './muiGlobalOverrides';
export function createBranchTheme() {
    return createTheme({
        palette: palette,
        typography: createBranchTypography,
        components: Components,
        shadows: Shadows,
        colors: Colors,
    });
}
export const theme = createBranchTheme();
//# sourceMappingURL=Theme.constants.js.map